import { Logout } from '@mui/icons-material';
import SupportAgentIcon from '@mui/icons-material/SupportAgent';
import { Container } from './styles';

import { useAuth } from '../../context';
import { useState } from 'react';
import { ModalContactUs } from '../Modals/ModalContactUs';
import { useConfig } from '../../context/configCustom';

interface InteractiveOptionsProps {
  handleIsOpenModal: (isOpen: boolean) => void;
}

export function InteractiveOptions({ handleIsOpenModal }: InteractiveOptionsProps) {
  const { uiVisibilitySettings } = useConfig();
  const { logout } = useAuth();
  const [isOpenSupportModal, setIsOpenSupportModal] = useState(false);

  function handleOpenModal(isOpen: boolean) {
    setIsOpenSupportModal(isOpen);
    handleIsOpenModal(isOpen);
  }
  function handleCloseModal() {
    setIsOpenSupportModal(false);
    handleIsOpenModal(false);
  }
  return (
    <Container>
      {uiVisibilitySettings?.showContactUsOption && (
        <button type="button" className="optionMenuNavBar" onClick={() => handleOpenModal(true)}>
          <SupportAgentIcon />
          <p>Fale conosco</p>
        </button>
      )}
      <button type="button" className="optionMenuNavBar" onClick={logout}>
        <Logout />
        <p>Sair</p>
      </button>
      {isOpenSupportModal && (
        <ModalContactUs isOpen={isOpenSupportModal} onRequestClose={handleCloseModal} />
      )}
    </Container>
  );
}
